/** Останній відомий стан — щоб перший кадр не показував чужий.
 *
 * Owner 2026-09-05: «опять что-то моргает на главной». Чекати відповіді не
 * можна (це коштує пів секунди на кожному відкритті), заглушка теж помітна —
 * бо коли дані приїжджають, блоки зʼявляються й розсувають сторінку.
 *
 * Рішення: памʼятаємо на пристрої те, що визначає ВИГЛЯД (є підписка чи ні, чи
 * доступний оберт), і малюємо перший кадр за ним. У переважній більшості
 * випадків стан не змінився, тож і моргати нічому. Якщо змінився — сторінка
 * оновиться один раз, і це чесно: стан справді інший.
 */
const PREFIX = "lk_";

export function remember(key: string, value: boolean): void {
  try {
    localStorage.setItem(PREFIX + key, value ? "1" : "0");
  } catch {
    /* приватний режим — просто без памʼяті */
  }
}

export function recall(key: string): boolean | undefined {
  try {
    const v = localStorage.getItem(PREFIX + key);
    return v === null ? undefined : v === "1";
  } catch {
    return undefined;
  }
}
